import type { FaireProductEntity } from "../../entity_types/product";

export const p_95qcmfjjbw: FaireProductEntity = {
  token: "p_95qcmfjjbw",
  type: "product",
  name: '3" Showcase Quality Arrowheads - 12 Quantity',
  brandToken: "b_46yqo0x0y0",
  brandName: "El Paso Saddleblanket",
  imageUrl:
    "https://cdn.faire.com/fastly/fff3e160c38482a43ff23a4b6d8935f73d3eb041b1f4b3518417dace67d01367.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eeedbf0839b8f8b24103383fde6be752ed0d99994cf2c9efd73dff039214c262.jpeg",
  ],
  priceDollars: 31.59,
  description:
    'Our 3 inch Showcase Quality arrowheads are hand-chipped from genuine agate and other stones, these handcrafted arrowheads are the highest grade available anywhere.\n\nGreat for promotional giveaways, "artifact" making, and most importantly, for sales directly to your customers.\n\nImported.\n\n*As these are hand-chipped, sizes are approximate \n\nEight sizes available ranging from 1" to Large spearhead size 5"-6".',
  tags: [],
  msrpDollars: 63.19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:56.810Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
